module.exports = __webpack_public_path__ + "static/media/calendar-select.1fa4f9a5.svg";